"use client";

import { useEffect, useState } from "react";

/** Ширина, с которой в портале появляется боковой рельс (Tailwind `lg`). */
const DESKTOP = "(min-width: 1024px)";

/**
 * Десктопная ли ширина сейчас.
 *
 * ⚠️ НЕ CSS-КЛАССОМ. Панель портала (уведомления, чат, профиль) держит замок
 * «одна на экран»: кто смонтировался первым, тот и рисует. Спрятать лишнюю
 * копию классом `lg:hidden` нельзя — она всё равно монтируется, забирает замок,
 * и настоящая панель молча исчезает. Поэтому копии должны именно НЕ
 * монтироваться, а для этого нужна проверка в JS.
 *
 * До первого измерения возвращает `true`: на сервере ширины нет, а десктопная
 * раскладка — основная.
 */
export function useIsDesktop(): boolean {
  const [desktop, setDesktop] = useState(true);
  useEffect(() => {
    const mq = window.matchMedia(DESKTOP);
    const apply = () => setDesktop(mq.matches);
    apply();
    mq.addEventListener("change", apply);
    return () => mq.removeEventListener("change", apply);
  }, []);
  return desktop;
}
